import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { Language as LanguageIcon } from "@mui/icons-material";
import { useLanguage } from "../contexts/LanguageContext";

const LanguageToggle: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "ar" : "en");
  };

  return (
    <Tooltip title={t("language.toggle")}>
      <Button
        variant="outlined"
        size="small"
        onClick={toggleLanguage}
        sx={{
          backgroundColor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          color: "text.secondary",
          minWidth: "auto",
          px: 2,
          gap: 0.8,
          "& .language-toggle-icon": {
            flexShrink: 0,
          },
          "&:hover": {
            backgroundColor: "action.hover",
          },
          boxShadow: 1,
        }}
      >
        <Box component="span">{language === "en" ? "العربية" : "English"}</Box>
        <LanguageIcon className="language-toggle-icon" fontSize="small" />
      </Button>
    </Tooltip>
  );
};

export default LanguageToggle;
